'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'

export const JCodeActivitySelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  menuZindex = 1100,
  menuWidth = null,
  menuOffset = null
}) => {
  const { fetchJCodeActivityCodes, jCodeActivityCodes } = useTimeRecordingStore()
  const [options, setOptions] = useState(testData || jCodeActivityCodes || [])

  useEffect(() => {
    if (testData) return
    setOptions(jCodeActivityCodes || [])
  }, [testData, jCodeActivityCodes])

  useEffect(() => {
    if (testData || jCodeActivityCodes.length) return
    fetchJCodeActivityCodes()
  }, [testData, fetchJCodeActivityCodes, jCodeActivityCodes])

  return (
    <div
      data-testid="JCodeActivitySelect"
      style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', minWidth: sx?.minWidth || '0' }}
    >
      <ReactSelectMenu
        label="Activity code"
        onChange={onChange}
        labelKey="name"
        valueKey="jCodeActivityId"
        items={options}
        value={value}
        sx={{ width: '100%' }}
        searchable
        idLabelKey="jCodeActivityCode"
        menuOffset={menuOffset}
        name="jCodeActivityCode"
        menuZindex={menuZindex}
        menuWidth={menuWidth}
      />
    </div>
  )
}

JCodeActivitySelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  menuZindex: PropTypes.number,
  menuWidth: PropTypes.string,
  menuOffset: PropTypes.string
}
